module.exports = __webpack_public_path__ + "static/media/reset-button-active.f64f8eff.svg";